<template>
  <boxwrap class="leagues--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <select-list
            class="toolbar-nav"
            ref="selectGame"
            :title="filterStatus ? $route.params.status : 'All'"
            :withReset="true"
            v-model="filterStatus"
            @input="change"
          >
          <select-option value="all" name="all">all</select-option>
          <select-option value="active" name="active">active</select-option>
          <select-option value="inactive" name="inactive">inactive</select-option>
        </select-list>

        <search
          class ="search-bar-wrap -withdropdown"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @refresh="search"
          @trigger="trigger"
        >
        </search>

        <button
          class="btn--create"
          @click="showCreate = true"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--delete"
        >
          <i class="ico--delete"></i>
        </button>

        <button
          class="btn--restore"
        >
          <i class="ico--restore"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--import-csv"
          >
            <i class="ico--import"></i>
          </button>

          <button
            class="btn--export-csv"
          >
            <i class="ico--export"></i>
          </button>

          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
        v-else
      >
        <tbl-inner>
          <tbl-head>
            <tbl-row>
              <tbl-td class="checkbox">
                <checkbox>
                  <input type="checkbox" />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                :sort="true"
                @click.native="sort('id')"
                v-if="checkCol('no', tblSetting)"
              >
                no
              </tbl-td>

              <tbl-td
                name="created-at"
                :sort="true"
                @click.native="sort('created_at')"
                v-if="checkCol('created_at', tblSetting)"
              >
                created at
              </tbl-td>

              <tbl-td
                name="game"
                :sort="true"
                @click.native="sort('game')"
                v-if="checkCol('game', tblSetting)"
              >
                game
              </tbl-td>

              <tbl-td
                class="country"
                v-if="checkCol('country', tblSetting)"
              >
                country
              </tbl-td>

              <tbl-td
                class="icon"
                v-if="checkCol('icon', tblSetting)"
              >
                icon
              </tbl-td>

              <tbl-td
                name="league-name-en"
                :sort="true"
                @click.native="sort('name')"
                v-if="checkCol('league_name_en', tblSetting)"
              >
                league name (en)
              </tbl-td>

              <tbl-td
                name="league-name-kr"
                :sort="true"
                @click.native="sort('kor')"
                v-if="checkCol('league_name_kr', tblSetting)"
              >
                league name (ko)
              </tbl-td>

              <tbl-td
                name="is-active"
                :sort="true"
                @click.native="sort('active')"
                v-if="checkCol('is_active', tblSetting)"
              >
                is active
              </tbl-td>

              <tbl-td
                name="updated-at"
                :sort="true"
                @click.native="sort('updated_at')"
                v-if="checkCol('updated_at', tblSetting)"
              >
                updated at
              </tbl-td>

              <tbl-td
                class="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                deleted at
              </tbl-td>

              <tbl-td
                class="delete-edit"
                v-if="checkPermission"
              >
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(league, id) in all"
              :key="league.id"
              @click.native="modify(league)"
              :class="{'is-deleted': league.deleted_at}"
            >
              <tbl-td class="checkbox" @click.native.stop>
                <checkbox>
                  <input type="checkbox" />
                </checkbox>
              </tbl-td>

              <tbl-td
                class="no"
                v-if="checkCol('no', tblSetting)"
              >
                {{ generateNumber(id, params.page, params.rows, params.sort, count || 0) }}
              </tbl-td>

              <tbl-td
                class="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                {{ league.created_at | date }}
              </tbl-td>

              <tbl-td
                class="game"
                v-if="checkCol('game', tblSetting)"
              >
                {{ league.game.name }}
              </tbl-td>

              <tbl-td
                class="country"
                v-if="checkCol('country', tblSetting)"
              >
                <img v-if="league.venue && league.venue.images" :src="basePath + league.venue.images">
              </tbl-td>

              <tbl-td
                class="icon"
                v-if="checkCol('icon', tblSetting)"
              >
                <img v-if="league.images" :src="basePath + league.images">
              </tbl-td>

              <tbl-td
                class="league-name-en"
                v-if="checkCol('league_name_en', tblSetting)"
              >
                {{ league.name }}
              </tbl-td>

              <tbl-td
                class="league-name-kr"
                v-if="checkCol('league_name_kr', tblSetting)"
              >
                {{ league.kor }}
              </tbl-td>

              <tbl-td
                class="is-active"
                v-if="checkCol('is_active', tblSetting)"
              >
                <checkbox
                  type="toggle"
                  class="toggle--inverted"
                  toggleA="active"
                  toggleB="inactive"
                  @click.native.stop.prevent="toggleLeagueActive(league)"
                >
                  <input
                    type="checkbox"
                    v-model="league.active"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                class="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                {{ league.updated_at | date }}
              </tbl-td>

              <tbl-td
                class="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                {{ league.deleted_at | date }}
              </tbl-td>

              <tbl-td
                class="delete-edit"
                v-if="checkPermission"
                @click.native.stop
              >
                <button @click="confirmRemove(league.id)" class="btn--delete">
                  <i class="ico--delete"></i>
                </button>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="count"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <modal
      class="modal--create"
      title="create league"
      v-if="showCreate"
      :activate="showCreate"
      @activate="showCreate = $event"
    >
      <template slot="body">
        <form
          class="form-con"
          @submit.prevent="save"
        >
          <div class="form-items">
            <div class="form-lbl"><span>country</span></div>
            <div class="form-data">
              <input-suggestion
                @search="searchCountry"
                v-model="newLeague.venue"
                placeholder="Country"
              >
                <span slot="selected">{{ newLeague.venue ? newLeague.venue.name : '' }}</span>
                <suggestion
                  slot="suggestion"
                  v-for="country in countries"
                  :key="country.id"
                  :value="country"
                >
                  {{ country.name }}
                </suggestion>
              </input-suggestion>
<!--               <select-list
                ref="selectCountry"
                :title="newLeague.venue_id"
                :withReset="true"
                v-model="newLeague.venue_id"
              >
                <select-option
                  v-for="country in countries"
                  :key="country.id"
                  :value="country.id"
                  :name="country.name"
                >
                  {{ country.name }}
                </select-option>
              </select-list> -->
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>game</span></div>
            <div class="form-data">
              <select-list
                ref="selectGame"
                :title="newLeague.game_type_id"
                :withReset="true"
                v-model="newLeague.game_type_id"
              >
                <select-option
                  v-for="game in games"
                  :key="game.id"
                  :value="game.id"
                  :name="game.name"
                >
                  {{ game.name }}
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>origin</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input type="text" v-model="newLeague.origin" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>league name (en)</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input type="text" v-model="newLeague.name" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>league name (kr)</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input type="text" v-model="newLeague.kor" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>active</span></div>
            <div class="form-data">
              <checkbox>
                <input type="checkbox" v-model="newLeague.active" />
              </checkbox>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Image</span></div>
            <div class="form-data">
              <div class="file-upload-wrap">
                <label for="create-league-image" class="file-upload--label">
                  <i class="ico--upload"></i>
                  <input
                    ref="image"
                    type="file"
                    id="create-league-image"
                    class="file-upload--input"
                  />
                </label>
              </div>
            </div>
          </div>
        </form>
      </template>

      <template slot="footer">
        <button class="btn--clear -withlabel" @click="clear">
          <i class="ico--clear"></i>
          <span>clear</span>
        </button>

        <button class="btn--create right -withlabel" @click="save('newLeague')">
          <i class="ico--create"></i>
          <span>create league</span>
        </button>
      </template>
    </modal>

    <modal
      class="modal--modify"
      title="modify league"
      v-if="showModify"
      :activate="showModify"
      @activate="showModify = $event"
    >
      <template slot="body">
        <form
          class="form-con"
          @submit.prevent="save"
        >
          <div class="form-items">
            <div class="form-lbl"><span>created at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ editLeague.created_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>updated at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ editLeague.updated_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>deleted at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ editLeague.deleted_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>country</span></div>
            <div class="form-data">
              <input-suggestion
                @search="searchCountry"
                v-model="editLeague.venue"
                placeholder="Country"
              >
                <span slot="selected">{{ editLeague.venue ? editLeague.venue.name : '' }}</span>
                <suggestion
                  slot="suggestion"
                  v-for="country in countries"
                  :key="country.id"
                  :value="country"
                >
                  {{ country.name }}
                </suggestion>
              </input-suggestion>
<!--               <select-list
                ref="selectCountry"
                :title="displayVenue(editLeague.venue_id)"
                :withReset="true"
                v-model="editLeague.venue_id"
              >
                <select-option
                  v-for="country in countries"
                  :key="country.id"
                  :value="country.id"
                  :name="country.name"
                >
                  {{ country.name }}
                </select-option>
              </select-list> -->
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>game</span></div>
            <div class="form-data">
              <select-list
                ref="selectGame"
                :title="displayLeague(editLeague.game_type_id)"
                :withReset="true"
                v-model="editLeague.game_type_id"
              >
                <select-option
                  v-for="game in games"
                  :key="game.id"
                  :value="game.id"
                  :name="game.name"
                >
                  {{ game.name }}
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>origin</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input type="text" v-model="editLeague.origin" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>league name (en)</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input type="text" v-model="editLeague.name" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>league name (kr)</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input type="text" v-model="editLeague.kor" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>active</span></div>
            <div class="form-data">
              <checkbox>
                <input type="checkbox" v-model="editLeague.active" />
              </checkbox>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Image</span></div>
            <div class="form-data">
              <div class="file-upload-wrap">
                <label for="edit-league-image" class="file-upload--label">
                  <i class="ico--upload"></i>
                  <input
                    ref="image"
                    type="file"
                    id="edit-league-image"
                    class="file-upload--input"
                  />
                </label>
              </div>
            </div>
          </div>
        </form>
      </template>

      <template slot="footer">
        <button
          class="btn--clear -withlabel"
          @click="clear"
        >
          <i class="ico--clear"></i>
          <span>clear</span>
        </button>

        <button
          class="btn--modify -right -withlabel"
          @click="save('editLeague')"
        >
          <i class="ico--save"></i>
          <span>modify</span>
        </button>
      </template>
    </modal>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<style scoped>
  .choose-image { }
  .choose-image input { display: none; }
</style>

<script>
import { mapGetters, mapActions } from 'vuex'

//= components
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import Modal from '@/components/base/Modal'

import '@/components/base/table/Table'
// import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'
import '@/components/base/input/InputSuggestion.js'

//= mixin
import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

export default {
  name: 'leagues',

  components: {
    Checkbox,
    Pagination,
    Search,
    CheckDataList,
    Modal
  },

  mixins: [
    swal,
    checkAll
  ],

  data () {
    return {
      filterSport: 'all',
      filterStatus: 'all',
      showTblSettings: false,
      showCreate: false,
      showModify: false,

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      tblSetting: 'leagues_list',

      allCols: [
        {
          value: 'no',
          display: 'no'
        },
        {
          value: 'created_at',
          display: 'created at'
        },
        {
          value: 'game',
          display: 'game'
        },
        {
          value: 'league_name_en',
          display: 'league name (en)'
        },
        {
          value: 'league_name_kr',
          display: 'league name (ko)'
        },
        {
          value: 'is_active',
          display: 'is active'
        },
        {
          value: 'updated_at',
          display: 'updated at'
        },
        {
          value: 'deleted_at',
          display: 'deleted at'
        },
        {
          value: 'icon',
          display: 'icon'
        },
        {
          value: 'country',
          display: 'country'
        }
      ],

      filterBy: [
        {
          value: 'name',
          display: 'Name'
        },
        {
          value: 'kor',
          display: 'Korean Name'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },

        {
          value: 'updated_at',
          display: 'updated at'
        },

        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      editLeague: {
        id: undefined,
        name: '',
        kor: '',
        game_type_id: '',
        image: {},
        venue: null
      },

      newLeague: {
        id: undefined,
        name: '',
        kor: '',
        game_type_id: '',
        image: {},
        venue: null
      }
    }
  },

  watch: {
    $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate($router.query))
    }
  },

  computed: {
    ...mapGetters('league', ['all', 'count']),
    ...mapGetters('country', ['countries']),
    ...mapGetters('game', { games: 'all' }),
    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    }
  },

  async created () {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/all`)
    }

    await this.getGames({ params: { rows: 1000 } })
    await this.getCountries({ rows: 1000 })
    await this.search(this.generate(this.$router.query))

    // == flags set
    this.isDataLoading = false
    this.showDataLoading = false
    if (!this.all.length) {
      this.isEmpty = true
    }
  },

  methods: {
    ...mapActions('league', ['get', 'create', 'update', 'remove', 'getCount']),
    ...mapActions('country', { getCountries: 'get' }),
    ...mapActions('game', { getGames: 'get' }),

    change () {
      this.params.page = 1
      this.$router.push({
        path: `/leagues/${this.filterStatus}/${this.filterSport}`,
        query: this.params
      })
    },

    confirmRemove (id) {
      this.$alert('prompt', 'Are you sure you want to delete?', {}, async () => {
        this.remove(id)
      }, 'Delete League')
    },

    displayVenue (id) {
      return this.countries.find((e) => { return e.id === id }).name
    },

    displayLeague (id) {
      return this.games.find((e) => { return e.id === id }).name
    },

    trigger (query) {
      this.params = query || this.params
      this.$router.push({
        path: `/leagues/${this.filterStatus}/${this.filterSport}`,
        query: this.params
      })
    },

    async search (query) {
      this.params = query || this.params

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.get({
        params: this.params, status: this.filterStatus, game: this.filterSport
      })

      await this.getCount({
        params: this.params, status: this.filterStatus, game: this.filterSport
      })

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.all.length) {
        this.isEmpty = true
      }
    },

    async save (key) {
      let result
      let alertTitle = this[key].id ? 'Modify League' : 'Create League'
      let success = async () => {
        if (this.$refs.image.files.length) {
          this.editLeague.image = this.$refs.image.files[0]
        }

        this[key].venue_id = this[key].venue.id

        if (this[key].id) {
          result = await this.update(this[key])
        } else {
          result = await this.create(this[key])
        }

        if (result.status === 201) {
          this.$alert('success', 'You have successfully created league.', {}, '', 'Success')
          this.showDataLoading = true
          this.showCreate = false
          this.search()
          this.clear()
        }

        if (result.status === 204) {
          this.$alert('success', 'You have successfully modified league.', {}, '', 'Success')
          this.showDataLoading = true
          this.showModify = false
          this.search()
          this.clear()
        }
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, alertTitle)
    },

    async searchCountry (q) {
      let params = { rows: 50 }

      if (q) {
        params.filter_by = 'name'
        params.q = q
      }

      await this.getCountries(params)
    },

    clear () {
      this.$refs.selectGame.reset = true
      this.$refs.selectCountry.reset = true
      this.$refs.image.value = ''
      this.editLeague = {
        id: undefined,
        name: '',
        kor: '',
        game_type_id: '',
        image: {},
        venue: null
      }
      this.newLeague = {
        id: undefined,
        name: '',
        kor: '',
        game_type_id: '',
        image: {},
        venue: null
      }
    },

    modify (league) {
      if (this.checkPermission) {
        this.editLeague = Object.assign({}, league)
        this.showModify = true
      }
    },

    toggleLeagueActive (league) {
      let success = async () => {
        league.active = !league.active
        await this.update(league)
      }

      this.$alert('prompt', 'Are you sure you want to proceed ?', {}, { success }, 'Modify ?')
    },

    sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.trigger()
    }
  }
}
</script>
